export function throwFn(err) {
  throw err;
}